var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicWheel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1112_40313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3125 22.6362C6.7925 22.6362 2.3125 18.1562 2.3125 12.6362C2.3125 7.11623 6.7925 2.63623 12.3125 2.63623C17.8325 2.63623 22.3125 7.11623 22.3125 12.6362C22.3125 18.1562 17.8325 22.6362 12.3125 22.6362ZM4.3125 12.6362C4.3125 13.2462 4.3925 13.8462 4.5225 14.4162L9.3025 9.63623V8.63623C9.3025 7.53623 10.2025 6.63623 11.3025 6.63623V4.70623C7.3725 5.20623 4.3125 8.56623 4.3125 12.6362ZM18.2025 7.23623C17.9425 8.04623 17.2025 8.63623 16.3025 8.63623H15.3025V11.6362C15.3025 12.1862 14.8525 12.6362 14.3025 12.6362H8.3025V14.6362H10.3025C10.8525 14.6362 11.3025 15.0862 11.3025 15.6362V17.6362H13.3025C14.4025 17.6362 15.3025 18.5362 15.3025 19.6362V20.0462C18.2325 18.8662 20.3125 15.9862 20.3125 12.6362C20.3125 10.5562 19.5025 8.65623 18.2025 7.23623Z",
    fill: "#018001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_40313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.3125 24.6362)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicWheel);
export default __webpack_public_path__ + "static/media/PublicWheel.6c6e813785a1e1ee2f9b74586da96796.svg";
export { ForwardRef as ReactComponent };